import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = 'Privacy Policy — tagIt';
  }, []);

  return (
    <div className="app">
      <Header />

      <main className="section">
        <div className="container">
          <div className="section-head">
            <h1>Privacy Policy</h1>
            <p>Last updated: April 8, 2026</p>
          </div>

          <article className="blog-prose">
            <p>
              tagIt respects your privacy. This policy explains what we collect on this website,
              how we use it, and the choices you have.
            </p>

            <h2>Information We Collect</h2>
            <p>We may collect the following types of information when you use this website:</p>
            <ul>
              <li>Information you provide through forms, such as your name, email address, and message.</li>
              <li>Usage information, such as pages viewed, links clicked, time on page, and referring pages.</li>
              <li>Device and browser information, such as browser type, operating system, and approximate location derived from IP address.</li>
              <li>Cookies or similar technologies used for analytics, security, and site functionality.</li>
            </ul>

            <h2>How We Use Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Respond to inquiries and communicate with you.</li>
              <li>Understand how people use our website.</li>
              <li>Improve the performance, content, and experience of the site.</li>
              <li>Maintain security and detect abuse or misuse.</li>
            </ul>

            <h2>Tracking and Analytics</h2>
            <p>
              We track users on this website with tagIt. We use tagIt to measure page views,
              clicks, navigation, and other interaction signals so we can understand how the site is
              being used and improve the experience.
            </p>
            <p>
              We may also use other standard analytics or logging tools as part of operating the
              website. These tools help us understand traffic, diagnose issues, and improve
              reliability.
            </p>

            <h2>How We Share Information</h2>
            <p>
              We do not sell your personal information. We may share information with service
              providers that help us operate the website, such as hosting, analytics, and email
              providers. We may also disclose information if required by law or to protect our rights
              and the security of the site.
            </p>

            <h2>Cookies and Similar Technologies</h2>
            <p>
              We may use cookies and similar technologies for analytics, security, and site
              functionality. You can adjust your browser settings to control cookies, but some parts
              of the website may not function properly if you disable them.
            </p>

            <h2>Data Retention</h2>
            <p>
              We keep personal information only as long as necessary for the purposes described in
              this policy, unless a longer retention period is required or permitted by law.
            </p>

            <h2>Your Choices</h2>
            <p>
              Depending on where you live, you may have rights to access, correct, delete, or
              restrict certain personal information. To make a request, contact us using the email
              below.
            </p>

            <h2>Security</h2>
            <p>
              We use reasonable administrative, technical, and organizational safeguards to protect
              the information we collect. No method of transmission or storage is completely secure,
              so we cannot guarantee absolute security.
            </p>

            <h2>Third-Party Links</h2>
            <p>
              This website may link to third-party sites or services. We are not responsible for the
              privacy practices of those sites, and their policies govern your use of them.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. If we make material changes, we
              will update the date above and post the revised policy on this page.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, contact us at{' '}
              <a href="mailto:hello@tagit.live">hello@tagit.live</a>.
            </p>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
}
